import FilterMixin from '@/shared/mixins/filter.mixin'
import DetailsMixin from '@/shared/mixins/details.mixin'
import AdminMixin from '@/shared/mixins/admin.mixin'
import DateMixin from '@/shared/mixins/date.mixin'
import AuthMixin from '@/shared/mixins/auth.mixin'
import DicomPlusMixin from '@/shared/mixins/dicom-plus.mixin'
import XPlusMixin from '@/shared/mixins/x-plus.mixin'
import ExamSourceMixin from '@/shared/mixins/exam-source.mixin'
import PrintProtocolMixin from '@/shared/mixins/print-protocol.mixin'
import XPlusModal from '../x-plus-modal/index.vue'
import AnexarArquivosModal from '../x-plus-modal/x-plus-import-files-modal.vue'
import CriarExameModal from '../x-plus-modal/criar-exame-modal.vue'
import XPlusHistoricoGrid from './x-plus-historico-grid/index.vue'
import XPlusCancelamento from './x-plus-cancelamento/index.vue'
import { showDialog } from '@/shared/sweetAlerts/showDialog'
import constants from '@/shared/constants/constants'
import { dateBrToInt } from '@/shared/utils/date-validator'
import PatientNameCell from '@/components/patient-name-cell/index.vue'

export default {
  name: 'x-plus-tab',
  mixins: [FilterMixin, DetailsMixin, AdminMixin, DateMixin, AuthMixin, XPlusMixin, DicomPlusMixin, ExamSourceMixin, PrintProtocolMixin],
  components: {
    XPlusModal,
    AnexarArquivosModal,
    CriarExameModal,
    XPlusHistoricoGrid,
    XPlusCancelamento,
    PatientNameCell,
  },
  props: {
    fonteFilter: { type: Object, default: null },
    studyDateFilter: { type: Object, default: null },
  },
  data() {
    return {
      showIdColumn: true,
      constants,
      showModal: false,
      selectedExam: null,
      headers: [
        this.$i18n.t('x_plus.id'),
        this.$i18n.t('x_plus.patient'),
        this.$i18n.t('x_plus.age'),
        this.$i18n.t('x_plus.sex'),
        this.$i18n.t('x_plus.exam_date'),
        this.$i18n.t('x_plus.speciality'),
        this.$i18n.t('x_plus.status'),
        this.$i18n.t('x_plus.reason'),
        this.$i18n.t('x_plus.unit'),
        this.$i18n.t('x_plus.actions'),
      ],
      placeholder: this.$i18n.t('x_plus.placeholder_patient_name'),
      examSources: [],
      status: [],
      tableData: [],
      totalItems: 0,
      currentPage: 1,
      PageSize: 20,
      pageCount: 1,
      isLoading: false,
      activeFilters: { Status: { value: 0 } },
      searchTerm: '',
      filtrarExamesCriados: false,
      OrderColumn: 'dataExame',
      OrderBy: 'desc',
      filtroStatus: '',
      statusItems: [
        { id: null, name: 'Todos' },
        { id: '0', name: 'Pendente' },
        { id: '1', name: 'Revisado' },
        { id: '2', name: 'Exame criado' },
        { id: '3', name: 'Falha' },
        { id: '4', name: 'Expirado' },
        { id: '5', name: 'Deletado' },
        { id: '6', name: 'Duplicado' },
        { id: '99', name: 'Cancelado' },
        { id: '1_6', name: 'Laudando' },
        { id: '1_10', name: 'Laudo liberado' }
      ],
      showAnexarArquivos: false,
      showCriarExame: false,
      showHistoricoExame: false,
      historico: [],
      detalhes: [],
      examAnexo: null,
      anexoTipoOptions: [],
      savedFiles: [],
      showCancelModal: false,
      motivoCancelamento: '',
      xPlusIdSelecionado: null,
      examToRestore: null,
      examToReactive: null,
    }
  },
  async mounted() {
    this.examSources = await this.getExamSourceList()
    this.status = await this.getStatus()
    this.buscarAnexoTipo()
    if (this.fonteFilter) {
      this.activeFilters = { ...this.activeFilters, FonteID: this.fonteFilter }
    }
    if (this.studyDateFilter) {
      this.activeFilters = { ...this.activeFilters, StudyDate: this.studyDateFilter }
    }
    this.$root.$emit('showLoading')
    this.fetchTableData(this.activeFilters, this.currentPage).finally(() => {
      this.$root.$emit('hideLoading')
    })
    const stored = localStorage.getItem('showIdColumn')
    if (stored !== null) this.showIdColumn = stored === 'true'
    window.addEventListener('keydown', this.handleKeyDown)
    window.addEventListener('keydown', this.preventF5AndReloadGrid)
  },
  beforeDestroy() {
    window.removeEventListener('keydown', this.handleKeyDown)
    window.removeEventListener('keydown', this.preventF5AndReloadGrid)
  },
  computed: {
    formattedExamSources() {
      return this.examSources.map(s => ({ id: s.id, value: s.description }))
    },
    podeCriarExame() {
      try {
        const source = JSON.parse(localStorage.getItem('selectedSource') || 'null')
        return source?.criarExameXPlus === true
      } catch (e) {
        return false
      }
    }
  },
  watch: {
    fonteFilter(newVal) {
      if (newVal) {
        this.activeFilters = { ...(this.activeFilters || {}), FonteID: newVal }
      } else if (this.activeFilters) {
        delete this.activeFilters.FonteID
      }
      this.currentPage = 1
      this.fetchTableData(this.activeFilters, 1)
    }
  },
  methods: {
    async fetchTableData(filters = null, Page = this.currentPage) {
      this.isLoading = true
      this.$root.$emit('showLoading')
      const { items, total, pageCount } = await this.getDicomPlus(
        filters, Page, this.PageSize, this.OrderColumn || 'dataExame', this.OrderBy || 'desc', 2
      )
      this.$root.$emit('hideLoading')
      this.tableData = items
      this.totalItems = total
      this.pageCount = pageCount
      this.isLoading = false
    },
    async refreshGrid() {
      this.$root.$emit('showLoading')
      await this.fetchTableData(this.activeFilters, this.currentPage)
      this.$root.$emit('hideLoading')
    },
    async buscarAnexoTipo() {
      this.anexoTipoOptions = await this.getFileTypes()
    },
    sortTable(field) {
      if (this.OrderColumn === field) {
        this.OrderBy = this.OrderBy === 'desc' ? 'asc' : 'desc'
      } else {
        this.OrderColumn = field
        this.OrderBy = 'asc'
      }
      this.fetchTableData(this.activeFilters, this.currentPage)
    },
    goToPage(Page) {
      if (Page < 1 || Page > this.pageCount) return
      this.currentPage = Page
      this.fetchTableData(this.activeFilters, Page)
    },
    nextPage() { this.goToPage(this.currentPage + 1) },
    prevPage() { this.goToPage(this.currentPage - 1) },
    onPageSizeChange() {
      this.currentPage = 1
      this.fetchTableData(this.activeFilters, 1)
    },
    applyFilter() {
      if (this.searchTerm && this.searchTerm.length >= 3) {
        this.activeFilters = { ...this.activeFilters, patientName: { value: this.searchTerm } }
        this.currentPage = 1
        this.fetchTableData(this.activeFilters, 1)
      } else {
        showDialog({
          icon: 'warning',
          title: this.$t('x_plus.dialog_message.warn'),
          text: this.$t('x_plus.dialog_message.enter_at_least_3_characteres_to_filter'),
          confirmButtonText: 'Ok',
        })
      }
    },
    clearTextFilter() { this.searchTerm = '' },
    toggleExamesCriados() {
      const filters = { ...(this.activeFilters || {}) }
      if (this.filtrarExamesCriados) {
        filters.ExameCriado = { value: true }
      } else {
        delete filters.ExameCriado
      }
      this.activeFilters = Object.keys(filters).length ? filters : null
      this.currentPage = 1
      this.fetchTableData(this.activeFilters, 1)
    },
    clearFilter() {
      this.searchTerm = ''
      this.filtroStatus = 0
      this.filtrarExamesCriados = false
      this.activeFilters = { Status: { value: 0 } }
      this.$emit('fonte-filter-changed', null)
      this.currentPage = 1
      this.fetchTableData(this.activeFilters, 1)
    },
    filtrarPorStatus(status) {
      let statusId = status
      if (status && typeof status === 'object' && 'id' in status) statusId = status.id
      if (statusId !== null && statusId !== undefined && statusId !== '') {
        this.filtroStatus = statusId
        this.activeFilters = { ...(this.activeFilters || {}), Status: { value: statusId } }
      } else {
        if (this.activeFilters) {
          delete this.activeFilters.Status
          if (Object.keys(this.activeFilters).length === 0) this.activeFilters = null
        }
        this.filtroStatus = ''
      }
      this.currentPage = 1
      this.fetchTableData(this.activeFilters, 1)
    },
    getFilterChipLabel(key, filter) {
      switch (key) {
        case 'Status': {
          let id = filter
          if (filter && typeof filter === 'object') {
            if ('id' in filter) id = filter.id
            else if ('value' in filter) id = filter.value
          }
          const item = this.statusItems.find(i => String(i.id) === String(id))
          return `Status: ${item ? item.name : id ?? ''}`
        }
        case 'FonteID': {
          if (filter && typeof filter === 'object' && filter.label) return `Fonte: ${filter.label}`
          if (filter && Array.isArray(filter.value)) {
            const labels = filter.value.map(fid => {
              const fonte = this.formattedExamSources.find(f => String(f.id) === String(fid))
              return fonte ? fonte.value : fid
            })
            return `Fonte: ${labels.join(', ')}`
          }
          const fonteID = filter && typeof filter === 'object' && 'value' in filter ? filter.value : filter
          const fonte = this.formattedExamSources.find(f => String(f.id) === String(fonteID))
          return `Fonte: ${fonte ? fonte.value : fonteID ?? ''}`
        }
        case 'patientName':
          return `Paciente: ${filter && typeof filter === 'object' ? filter.value : filter ?? ''}`
        case 'ExameCriado':
          return this.$t('x_plus.only_created_exams')
        case 'StudyDate': {
          let dateStr = filter
          if (typeof filter === 'object' && filter && filter.value) dateStr = filter.value
          if (dateStr && /^\d{4}-\d{2}-\d{2}$/.test(dateStr)) {
            const [yyyy, mm, dd] = dateStr.split('-')
            return `Período a partir de: ${dd}/${mm}/${yyyy}`
          }
          return `Período a partir de: ${dateStr ?? ''}`
        }
        default:
          return `${key}: ${filter && typeof filter === 'object' ? filter.value : filter ?? ''}`
      }
    },
    removeFilter(key) {
      if (this.activeFilters) {
        delete this.activeFilters[key]
        if (Object.keys(this.activeFilters).length === 0) this.activeFilters = null
      }
      if (key === 'patientName') this.searchTerm = ''
      if (key === 'ExameCriado') this.filtrarExamesCriados = false
      if (key === 'FonteID') this.$emit('fonte-filter-changed', null)
      this.currentPage = 1
      this.fetchTableData(this.activeFilters, 1)
    },
    async isExameAtribuido(item) {
      if (item?.status === constants.DICOM_PLUS_STATUS.REVISADO) {
        showDialog({
          icon: 'warning',
          title: this.$t('x_plus.dialog_message.exam_in_review_title'),
          text: this.$t('x_plus.dialog_message.exam_in_review_text'),
          confirmButtonText: 'Ok'
        })
        return
      }

      if (item?.status !== 0) {
        this.openModal(item)
        return
      }
      const res = await this.verificarExameEmUso(item.dicomPlusID)
      try {
        if (res.status === 200) this.openModal(item)
        if (res.status === 226) {
          showDialog({
            icon: 'warning',
            title: this.$t('x_plus.dialog_message.exam_in_use'),
            text: res.data?.data,
            confirmButtonText: 'Ok',
            confirmed: () => this.refreshGrid()
          })
        }
        if (res.status === 400) {
          showDialog({ icon: 'error', title: 'Ops...', text: res.data?.data, confirmButtonText: 'Ok' })
        }
      } catch (error) {
        showDialog({
          icon: 'error',
          title: this.$t('x_plus.dialog_message.error_when_opening_exam'),
          text: error.message,
          confirmButtonText: 'Ok'
        })
      }
    },
    openModal(item) {
      this.selectedExam = item
      this.showModal = true
    },
    async verificarExameEmUso(dicomPlusID) {
      return await this.isExamAssignedToUser(dicomPlusID)
    },
    async desbloquearExame(item) {
      await showDialog({
        title: this.$t('x_plus.dialog_message.unlock'),
        text: this.$t('x_plus.dialog_message.exam_in_use_by', { user: item.usuarioEmUso }),
        icon: 'question',
        confirmButtonText: this.$t('x_plus.dialog_message.yes_unlock'),
        denyButtonText: this.$t('x_plus.dialog_message.no_cancel'),
        confirmed: async () => {
          try {
            const res = await this.removeAssignedUserToExam(item.dicomPlusID)
            if (res.success === true) {
              showDialog({
                icon: 'success',
                title: this.$t('x_plus.dialog_message.exam_unlocked'),
                text: this.$t('x_plus.dialog_message.exam_unlocked_successfully'),
                confirmButtonText: 'Ok',
                confirmed: () => this.refreshGrid()
              })
            }
          } catch (error) {
            showDialog({ title: this.$t('x_plus.dialog_message.fail'), text: error, icon: 'warning', confirmButtonText: 'Ok' })
          }
        }
      })
    },
    async handleGetExamXView(item) {
      try {
        this.$root.$emit('showLoading')
        const files = await this.getFileList(item.dicomPlusID)
        if (!files.length) {
          showDialog({ icon: 'warning', title: this.$t('x_plus.dialog_message.fail'), text: this.$t('x_plus.dialog_message.download_error_link'), confirmButtonText: 'OK' })
          return
        }
        const sorted = [...files].sort((a, b) => a.dicomPlusFileID - b.dicomPlusFileID)
        const result = await this.criarUrlAssinadaDownloadCloud(sorted[0].dicomPlusFileID)
        if (result?.url) {
          window.open(result.url, '_blank')
        }
      } catch (error) {
        showDialog({ icon: 'error', title: this.$t('x_plus.dialog_message.download_error'), text: error, confirmButtonText: 'OK' })
      } finally {
        this.$root.$emit('hideLoading')
      }
    },
    loadExamSources(data) {
      return new Promise(async (resolve) => {
        try {
          if (!data.page) this.examSources = []
          let sources = await this.getExamSourceList(data.page, this.limit, data.search)
          if (!Array.isArray(sources)) {
            sources = sources?.list && Array.isArray(sources.list) ? sources.list : []
          }
          const newSources = sources.filter(s => !this.examSources.some(e => e.id === s.id))
          this.examSources = [...this.examSources, ...newSources]
          resolve()
        } catch (error) {
          showDialog({
            icon: 'error',
            title: this.$t('x_plus.dialog_message.search_data_error'),
            text: error || this.$t('error.loading_sources'),
            confirmButtonText: 'Ok',
          })
          resolve([])
        }
      })
    },
    filterByExamSource(value) {
      const id = Array.isArray(value) ? value.map(v => v.id) : value.id
      const fonteFilter = { value: id }
      this.activeFilters = { ...(this.activeFilters || {}), FonteID: fonteFilter }
      this.$emit('fonte-filter-changed', fonteFilter)
      this.currentPage = 1
      this.fetchTableData(this.activeFilters, 1)
    },
    getStatusLabel(status) {
      const item = this.statusItems.find(i => String(i.id) === String(status))
      return item ? item.name : status ?? ''
    },
    getStatusClass(status) {
      const map = {
        '0': 'status primary',
        '1': 'status success',
        '2': 'status info',
        '3': 'status warning',
        '4': 'status expired',
        '5': 'status deleted',
        '6': 'status duplicate',
        '99': 'status danger',
        '1_6': 'status reporting',
        '1_10': 'status reported',
      }
      return map[status] || 'status-default'
    },
    getStatusIcon(status) {
      const map = {
        '0': 'alarm',
        '1': 'check',
        '2': 'assignment',
        '3': 'warning',
        '4': 'hourglass_bottom',
        '5': 'delete',
        '6': 'content_copy',
        '99': 'close',
        '1_6': 'assignment_ind',
        '1_10': 'assignment_turned_in',
      }
      return map[status] || 'fas fa-circle'
    },
    async abrirModalAnexarArquivos(item) {
      this.examAnexo = item
      await this.buscarListaDeArquivos(item)
      this.showAnexarArquivos = true
    },
    async buscarListaDeArquivos(item) {
      const dicomPlusID = item?.dicomPlusID
      if (!dicomPlusID) return
      this.savedFiles = (await this.getFileList(dicomPlusID)) || []
    },
    fecharModalAnexarArquivos() {
      this.showAnexarArquivos = false
      this.examAnexo = null
    },
    async abrirModalCriarExame() {
      if (!this.examSources.length) {
        await this.loadExamSources({ page: 0 })
      }
      this.showCriarExame = true
    },
    fecharModalCriarExame() {
      this.showCriarExame = false
    },
    async salvarCriarExame({ files, sourceID, specialityID }) {
      const listaArquivos = Array.isArray(files) ? files.filter(Boolean) : []
      if (!listaArquivos.length || !sourceID) return
      const fonteID = sourceID
      const arquivosComMD5 = []
      const filesPayload = []
      try {
        this.$root.$emit('showLoading')

        for (const file of listaArquivos) {
          const md5 = await this.gerarMD5(file)
          arquivosComMD5.push({ file, md5 })
        }

        const validacao = await this.validarArquivosXPlus(
          arquivosComMD5.map(({ file, md5 }) => ({ FileName: file.name, MD5: md5 }))
        )
        if (!validacao.success) {
          const mensagens = (validacao.errors || []).map(err =>
            this.$t('x_plus.dialog_message.file_already_in_database', { fileName: err.Property ?? err.property })
          )
          showDialog({
            icon: 'warning',
            title: this.$t('x_plus.dialog_message.warn'),
            text: mensagens.length ? mensagens.join('\n') : this.$t('x_plus.create_exam_fail'),
            confirmButtonText: 'OK'
          })
          return
        }

        for (const { file, md5 } of arquivosComMD5) {
          // TODO: reativar upload para o bucket. Comentado temporariamente para testar
          // em produção sem erro de CORS. Usando link mocado enquanto isso.
          // const urlInfo = await this.criarUrlAssinadaUploadCloud(file)
          // if (!urlInfo.success) {
          //   showDialog({
          //     icon: 'error',
          //     title: this.$t('x_plus.create_exam_fail'),
          //     text: urlInfo.message,
          //     confirmButtonText: 'OK'
          //   })
          //   return
          // }
          // const uploadResult = await this.uploadExameStorage(urlInfo.uploadUrl, file)
          // if (!uploadResult.success) {
          //   showDialog({
          //     icon: 'error',
          //     title: this.$t('x_plus.create_exam_fail'),
          //     text: uploadResult.message,
          //     confirmButtonText: 'OK'
          //   })
          //   return
          // }
          // filesPayload.push({ LinkStorage: urlInfo.publicUrl, MD5: md5 })
          const linkMocado = `gs://bucket-mock/xplus/${file.name}`
          filesPayload.push({ LinkStorage: linkMocado, MD5: md5 })
        }
        const createResult = await this.criarExameDicomPlus({
          fonteID: Number(fonteID),
          tipoRegistro: 2,
          especialidadeID: Number(specialityID),
          files: filesPayload
        })
        if (!createResult.success) {
          showDialog({
            icon: 'error',
            title: this.$t('x_plus.create_exam_fail'),
            text: createResult.message,
            confirmButtonText: 'OK'
          })
          return
        }
        showDialog({
          icon: 'success',
          title: this.$t('x_plus.dialog_message.success'),
          text: this.$t('x_plus.create_exam_success'),
          confirmButtonText: 'OK'
        })
        this.fecharModalCriarExame()
        this.OrderColumn = 'dataExame'
        this.OrderBy = 'desc'
        this.currentPage = 1
        await this.fetchTableData(this.activeFilters, 1)
      } catch (e) {
        showDialog({
          icon: 'error',
          title: this.$t('x_plus.create_exam_fail'),
          text: e && e.message ? e.message : String(e),
          confirmButtonText: 'OK'
        })
      } finally {
        this.$root.$emit('hideLoading')
      }
    },
    async salvarArquivos({ files }) {
      const dicomPlusID = this.examAnexo?.dicomPlusID
      const filesPayload = []
      try {
        this.$root.$emit('showLoading')

        const validacao = await this.validarArquivosXPlus(
          files.map(file => ({ FileName: file.name, MD5: file.md5 }))
        )
        if (!validacao.success) {
          const mensagens = (validacao.errors || []).map(err =>
            this.$t('x_plus.dialog_message.file_already_in_database', { fileName: err.Property ?? err.property })
          )
          showDialog({
            icon: 'warning',
            title: this.$t('x_plus.dialog_message.warn'),
            text: mensagens.length ? mensagens.join('\n') : this.$t('x_plus.create_exam_fail'),
            confirmButtonText: 'OK'
          })
          return
        }

        for (const file of files) {
          const urlInfo = await this.criarUrlAssinadaUploadCloud(file)
          if (!urlInfo.success) {
            showDialog({ icon: 'error', title: this.$t('x_plus.dialog_message.fail'), text: urlInfo.message, confirmButtonText: 'OK' })
            continue
          }
          const uploadResult = await this.uploadExameStorage(urlInfo.uploadUrl, file.file)
          if (!uploadResult.success) {
            showDialog({ icon: 'error', title: this.$t('x_plus.dialog_message.fail_save_storage'), text: uploadResult.message, confirmButtonText: 'OK' })
            continue
          }
          filesPayload.push({ linkStorage: urlInfo.publicUrl, tipoAnexo: file.tipoAnexo })
        }
        if (filesPayload.length) {
          const resultado = await this.salvarAnexoLocal({ dicomPlusID, files: filesPayload })
          if (!(resultado && resultado.success)) {
            showDialog({ icon: 'error', title: this.$t('x_plus.dialog_message.fail'), text: resultado.message || 'Erro ao salvar arquivos', confirmButtonText: 'OK' })
          } else {
            showDialog({ icon: 'success', title: this.$t('x_plus.dialog_message.success'), text: this.$t('x_plus.dialog_message.files_saved_succesfully'), confirmButtonText: 'OK' })
          }
        }
      } finally {
        await this.buscarListaDeArquivos(this.examAnexo)
        this.$refs.importFilesModal.clearImportedFiles()
        this.$root.$emit('hideLoading')
      }
    },
    async confirmaExcluirArquivoSalvo(id) {
      await showDialog({
        title: this.$t('x_plus.dialog_message.confirmation'),
        text: this.$t('x_plus.dialog_message.confirm_attachment_deletion'),
        confirmButtonText: this.$t('x_plus.yes'),
        denyButtonText: this.$t('x_plus.no'),
        icon: 'question',
        focusConfirm: false,
        focusDeny: true,
        confirmed: () => this.excluirArquivoSalvo(id)
      })
    },
    async excluirArquivoSalvo(id) {
      try {
        this.$root.$emit('showLoading')
        await this.deleteFiles(id)
        await this.buscarListaDeArquivos(this.examAnexo)
        showDialog({ icon: 'success', title: this.$t('x_plus.dialog_message.success'), text: this.$t('x_plus.dialog_message.files_removed_succesfully'), confirmButtonText: 'OK' })
      } catch (e) {
        showDialog({ icon: 'error', title: this.$t('x_plus.dialog_message.delete_error'), text: e, confirmButtonText: 'OK' })
      } finally {
        this.$root.$emit('hideLoading')
      }
    },
    async abrirModalHistoricoExame(item) {
      const dicomPlusID = item?.dicomPlusID
      if (!dicomPlusID) return
      this.$root.$emit('showLoading')
      try {
        const res = await this.getDicomPlusHistory(dicomPlusID)
        this.historico = res?.timeLineHistories || []
        this.detalhes = res?.details || []
        this.xPlusIdSelecionado = dicomPlusID
        this.showHistoricoExame = true
      } catch (error) {
        showDialog({
          icon: 'error',
          title: this.$t('x_plus.dialog_message.search_data_error') || 'Erro',
          text: error?.message ? error.message : String(error),
          confirmButtonText: 'Ok',
        })
      } finally {
        this.$root.$emit('hideLoading')
      }
    },
    async handleDownloadLink(dicomPlusFileID) {
      this.$root.$emit('showLoading')
      try {
        const result = await this.criarUrlAssinadaDownloadCloud(dicomPlusFileID)
        if (result) {
          window.open(result.url, '_blank')
        } else {
          showDialog({ icon: 'error', title: this.$t('x_plus.dialog_message.error_getting_download_link'), text: this.$t('x_plus.dialog_message.error_getting_download_link'), confirmButtonText: 'Ok' })
        }
      } catch (error) {
        showDialog({ icon: 'error', title: this.$t('x_plus.dialog_message.failed_download_file'), text: error || this.$t('x_plus.dialog_message.failed_download_file'), confirmButtonText: 'Ok' })
      } finally {
        this.$root.$emit('hideLoading')
      }
    },
    async confirmarRestaurarExame(item) {
      this.examToRestore = item
      await showDialog({
        title: this.$t('x_plus.dialog_message.confirmation'),
        text: this.$t('x_plus.dialog_message.confirm_to_restore'),
        confirmButtonText: this.$t('x_plus.yes'),
        denyButtonText: this.$t('x_plus.no'),
        icon: 'question',
        focusConfirm: false,
        focusDeny: true,
        confirmed: this.restoreXPlus
      })
    },
    async restoreXPlus() {
      if (!this.examToRestore) return
      const { dicomPlusID, status: statusExame } = this.examToRestore
      this.$root.$emit('showLoading')
      try {
        if (statusExame === constants.DICOM_PLUS_STATUS.CANCELADO) {
          await this.restoreCanceledExam(dicomPlusID)
        } else if (statusExame === constants.DICOM_PLUS_STATUS.FALHA) {
          await this.restoreFailedExam(dicomPlusID)
        } else {
          throw new Error(this.$t('x_plus.dialog_message.invalid_status'))
        }
        showDialog({ icon: 'success', title: this.$t('x_plus.dialog_message.success'), text: this.$t('x_plus.dialog_message.restored_successfully'), confirmButtonText: 'Ok' })
        this.refreshGrid()
      } catch (error) {
        showDialog({ icon: 'warning', title: this.$t('x_plus.dialog_message.warn'), text: error || this.$t('x_plus.dialog_message.error_validating_data'), confirmButtonText: 'Ok' })
      } finally {
        this.$root.$emit('hideLoading')
      }
    },
    async confirmarReativarExame(item) {
      this.examToReactive = item
      await showDialog({
        title: this.$t('x_plus.dialog_message.confirmation'),
        text: this.$t('x_plus.dialog_message.confirm_to_reactive'),
        confirmButtonText: this.$t('x_plus.yes'),
        denyButtonText: this.$t('x_plus.no'),
        icon: 'question',
        focusConfirm: false,
        focusDeny: true,
        confirmed: this.reactiveXPlus
      })
    },
    async reactiveXPlus() {
      if (!this.examToReactive) return
      const e = this.examToReactive
      const payload = {
        dicomPlusID: e.dicomPlusID,
        studyInstanceUID: e.studyInstanceUID,
        accessionNumber: e.accessionNumber,
        stationName: e.stationName,
        fonteID: e.fonteID,
        modality: e.categoria,
        patientName: e.paciente,
        patientID: e.patientID,
        patientBirthDate: dateBrToInt(e.dataNascimento),
        patientSex: e.sexo?.trim(),
        studyDescription: e.studyDescription,
        patientComments: e.comentarios || '',
        tituloLaudo: e.tituloLaudo || null,
        status: constants.DICOM_PLUS_STATUS.PENDENTE,
        studyDate: e.studyDate,
        studyTime: e.studyTime,
        requestingPhysicianName: e.requestingPhysicianName,
        patientWeight: e.patientWeight,
        token: e.token,
        especialidadeID: e.especialidade || '',
        subEspecialidade: e.subEspecialidade || '',
        contraste: e.contraste || '',
        contrasteVia: e.contrasteVia || '',
        contrasteTipo: e.contrasteTipo || '',
        trauma: e.trauma || '',
        avc: e.avc || '',
        leito: e.leito || '',
        oncologico: e.oncologico || '',
        prioridade: e.prioridade || '',
        tagsPlus: e.dadosComplementaresJSON || '',
        mamografia: e.mamografia || '',
        medicoID: e.medicoID || '',
        nomeMedico: e.nomeMedico || '',
      }
      this.$root.$emit('showLoading')
      try {
        await this.updatePacienteXPlus(payload)
        showDialog({ icon: 'success', title: this.$t('x_plus.dialog_message.success'), text: this.$t('x_plus.dialog_message.reactived_successfully'), confirmButtonText: 'Ok' })
        this.refreshGrid()
      } catch (error) {
        showDialog({ icon: 'error', title: this.$t('x_plus.dialog_message.error'), text: (error && error.message) || error || this.$t('x_plus.dialog_message.error_validating_data'), confirmButtonText: 'Ok' })
      } finally {
        this.$root.$emit('hideLoading')
      }
    },
    abrirCancelamento(item) {
      if (!item?.dicomPlusID) return
      this.xPlusIdSelecionado = item.dicomPlusID
      this.localMotivoCancelamento = ''
      this.showCancelModal = true
    },
    fecharCancelamento() {
      this.showCancelModal = false
      this.xPlusIdSelecionado = null
      this.localMotivoCancelamento = ''
    },
    handleKeyDown(e) {
      if (e.ctrlKey && e.key.toLowerCase() === 'i') {
        this.showIdColumn = !this.showIdColumn
        localStorage.setItem('showIdColumn', this.showIdColumn)
        e.preventDefault()
      }
    },
    preventF5AndReloadGrid(e) {
      if (e.key === 'F5' || e.keyCode === 116) {
        e.preventDefault()
        this.refreshGrid()
      }
    },
    printReport(examID){
      try {
        const route = this.$router.resolve({ name: 'examesPdf', query: { id: examID } })
        window.open(route.href, '_blank')
      } catch (error) {
        showDialog({
          icon: 'error',
          title: this.$t('x_plus.dialog_message.error'),
          text: error || this.$t('x_plus.dialog_message.error_printing_report'),
          confirmButtonText: 'Ok'
        })
      }
    }
  },
}
